<div class="container-section">
    <hr class="divider" [style.background-color]="info?.venue?.color" style="height: 20px;margin:0">

    <!-- Fila Superior: Banners -->
    <div class=" width-paginate cards-grid">

        <!-- Tarjeta 1: Vida Universitaria -->
        <article class="card-banner">
            <a [href]="url(info?.advertising?.link1)" target="_blank" rel="noopener noreferrer">
                <div class="card-image">
                <img class="mob" onerror="this.src='./assets/img/default.png'" [src]="info?.advertising?.image1MobilePath" alt="Chica con auriculares">
                <img class="desk" onerror="this.src='./assets/img/default.png'" [src]="info?.advertising?.image1Path" alt="Chica con auriculares">
            </div>
            </a>
        </article>

        <!-- Tarjeta 2: Biblioteca UCA -->
        <article class="card-banner">
           <a [href]="url(info?.advertising?.link2)" target="_blank" rel="noopener noreferrer">
             <div class="card-image">
                <img class="mob"  onerror="this.src='./assets/img/default.png'" [src]="info?.advertising?.image2MobilePath" alt="Chica con libros">
                <img class="desk"  onerror="this.src='./assets/img/default.png'" [src]="info?.advertising?.image2Path" alt="Chica con libros">
            </div>
           </a>
        </article>
    </div>

    <!-- Fila Inferior: Accesos Directos con Imágenes -->
    <div class="width-paginate shortcuts-grid" *ngIf="info?.advertising">
        <a [href]="url(item.link)"  target="_blank" rel="noopener noreferrer" class="shortcut-btn zoomIn" *ngFor="let item of info.advertising.items">
            <img onerror="this.src='./assets/img/default.png'"  [src]="item.iconPath" alt="Pastoral" class="shortcut-icon">
            <span class="quicksand-bold">{{item.title}}</span>
        </a>
    </div>
</div>